<div>
  <div class="d-none d-lg-block mb-1">
    <ul class="nav nav-tabs">
      @for (tab of tabNames | keyvalue; track tab) {
        @if (tab.value !== tabNames.tab3 || siteKeyExists) {
          <li class="nav-item" (click)="changeTab(tab.value)">
            <a
              class="nav-link"
              [ngClass]="selectedTab === tab.value ? 'active' : ''"
              >{{ tab.value }}</a
            >
          </li>
        }
      }
    </ul>
  </div>
  <div class="d-block d-lg-none my-2">
    <select
      class="form-select form-select-lg"
      (change)="selectTabDropDown($event)"
    >
      @for (tab of tabNames | keyvalue; track tab) {
        @if (tab.value !== tabNames.tab3 || siteKeyExists) {
          <option [value]="tab.value">
            {{ tab.value }}
          </option>
        }
      }
    </select>
  </div>
</div>

@if (selectedTab === tabNames.tab1) {
  <gtapp-sites></gtapp-sites>
} @else if (selectedTab === tabNames.tab2) {
  <div class="d-flex">
    <div class="col-lg-5 col-xl-4">
      <div class="d-flex gap-2 mb-2">
        @if (totalClientCount > 0) {
          <div class="flex-grow-1">
            <gtapp-auto-complete
              [data]="clientDropDownList"
              placeHolder="Search Clients"
              searchKeyword="company_name"
              [itemTemplate]="clientTemplate"
              [initialValue]="clientSearchString"
              (inputChanged)="onClientLookup($event)"
              (selected)="openCustomerView($event)"
              (submitted)="
                clearValues(); clientSearchString = $event; getClientListData()
              "
            >
            </gtapp-auto-complete>
            <ng-template #clientTemplate let-item>
              <div>{{ item?.company_name }}</div>
              @if (item?.full_address) {
                <div class="text-secondary small-font">
                  {{ item?.full_address }}
                </div>
              }
            </ng-template>
          </div>
        }
        <div class="d-flex gap-2">
          <button
            class="btn btn-primary"
            (click)="openAddClientForm()"
            id="addClient"
          >
            + Add Client
          </button>

          @if (archivedCount) {
            <button
              class="btn btn-secondary"
              (click)="getArchivedUnarchivedList()"
              id="clientDeleteBtn"
            >
              {{ showArchivedList ? "Show Active" : "Show Deleted" }}
            </button>
          }
        </div>
      </div>
      @if (showArchivedList) {
        <div class="fw-bold text-center my-3" role="alert">
          Showing Deleted Clients
        </div>
      }

      <gtapp-gt-custom-table
        [deskTopTableData]="clientPaginationData[pageNumClients] || []"
        [desktopTableDetails]="clientDetailsTableView"
        [tableStyle]="tableStyle"
        [otherParams]="otherParamsClients"
        (sortColumn)="sortColumnClient($event)"
        (searchColumn)="searchColumnClient($event)"
        (rowClick)="openCustomerView($event)"
        (paginationChange)="onChangePaginationClient($event)"
      ></gtapp-gt-custom-table>
    </div>
  </div>
} @else if (selectedTab === tabNames.tab3) {
  <gtapp-site-key-list></gtapp-site-key-list>
} @else if (selectedTab === tabNames.tab4) {
  <gtapp-sub-biller></gtapp-sub-biller>
}
